import { useCallback, useMemo } from 'react';
import { useStore } from 'src/contexts/StoreContext';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { style_desktop, style_mobile } from './ModalUploadToCart.styles';
import { useAddToCartETAInfo } from 'src/hooks/useAddToCartETAInfo';

export const useModalUploadToCart = () => {
  const {
    i18n,
    dynamicModal: { closeModal },
    project: { activeProduct, abortAddToCart },
  } = useStore();

  const { title, description } = useAddToCartETAInfo();

  const { isDesktop } = useResponsiveScreen();

  const style = useMemo(() => (isDesktop ? style_desktop : style_mobile), [isDesktop]);

  const handleAbort = useCallback(async () => {
    if (!activeProduct?.isCartCancellationEnabled) return;
    abortAddToCart();
    closeModal();
  }, [abortAddToCart, closeModal]);

  return {
    i18n,
    closeModal,
    activeProduct,
    abortAddToCart,
    style,
    title,
    handleAbort,
    description,
    isDesktop,
    progress: activeProduct?.progressUploadPercentage ?? 0,
  };
};
